import { render } from "./PopupEditGroup.vue?vue&type=template&id=494512e6&scoped=true"
import script from "./PopupEditGroup.vue?vue&type=script&lang=js"
export * from "./PopupEditGroup.vue?vue&type=script&lang=js"

import "./PopupEditGroup.vue?vue&type=style&index=0&id=494512e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-494512e6"]])

export default __exports__